import { useQuery } from '@tanstack/react-query';
import { getEnabledModels } from '@reflex/plugin-chat/web/api';
import { queryKeys } from '@/lib/query-keys';
import type { ChatModelStatus } from '@/lib/types';

export function useEnabledModels() {
  return useQuery({
    queryKey: queryKeys.chatModels,
    queryFn: async (): Promise<ChatModelStatus[]> => getEnabledModels(),
    staleTime: 30_000,
  });
}
